import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { P } from '@workramp/ui';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { WithWordWrapCss } from '~/styled-components/common/text';

interface AutoResizingTextProps extends ComponentPropsWithoutRef<typeof P> {
  baseFontSize?: number;
  children: ReactNode;
  shouldStartResizing?: boolean;
  maxHeight: string;
}

export const AutoResizingText = ({
  baseFontSize = 1,
  children,
  shouldStartResizing,
  className,
  maxHeight,
  ...props
}: AutoResizingTextProps) => {
  const containerRef = useRef<HTMLParagraphElement>();
  const textRef = useRef(null);
  const [fontSize, setFontSize] = useState(baseFontSize);

  useEffect(() => {
    makeFontFitContainer();
  }, [shouldStartResizing, fontSize]);

  const makeFontFitContainer = () => {
    const container = containerRef.current;
    const textElement = textRef.current;
    setTimeout(() => {
      if (textElement.clientHeight > container.clientHeight) {
        setFontSize((prevFontSize) => prevFontSize - 1);
      }
    }, 100);
  };

  return (
    <StyledTextContainer size={fontSize} className={className} ref={containerRef} $maxHeight={maxHeight} {...props}>
      <span ref={textRef} className="name" style={{ display: 'inline-block' }}>
        {children}
      </span>
    </StyledTextContainer>
  );
};

const StyledTextContainer = styled(P)<{ $maxHeight: string }>`
  ${WithWordWrapCss}
  max-height: ${({ $maxHeight }) => $maxHeight};
`;
